import { useMemo } from 'react';
import { ObjectField } from '../../interfaces/object-field';
import { Table } from '../../../../table/Table';
import { TableRow } from '../../../../table/interfaces/table';
import { getFieldsColumns } from './FieldsColumns';
import { ObjectFieldsMetaData } from '../../interfaces/object-field-header';
import { Integration } from '../../../../shared/interfaces/integration';

export interface FieldsTableProps {
  pipeline: Integration;
  selectedCount: number;
  totalCount: number;
  isListIndeterminate: boolean;
  isViewMode?: boolean;
  isListIncluded: boolean;
  fieldHeaders?: ObjectFieldsMetaData;
  filteredFields?: ObjectField[];
  changeSelectAllCheckedState: (included: boolean) => void;
  changeCheckedState: (field: ObjectField, included: boolean) => void;
  updateFieldProperty: (field: ObjectField, key: string, value: unknown) => void;
}

export function FieldsTable({
  selectedCount,
  totalCount,
  isViewMode,
  isListIndeterminate,
  isListIncluded,
  fieldHeaders,
  filteredFields,
  updateFieldProperty,
  changeSelectAllCheckedState,
  changeCheckedState,
  pipeline
}: FieldsTableProps) {
  const tableGlobalContext = {
    isViewMode,
    selectedCount,
    totalCount,
    isListIndeterminate,
    isListIncluded,
    changeSelectAllCheckedState,
    changeCheckedState,
    updateFieldProperty
  };

  const columns = useMemo(() => {
    if (!fieldHeaders) {
      return [];
    }

    return getFieldsColumns(fieldHeaders, pipeline);
  }, [fieldHeaders, pipeline]);

  const rows: TableRow<ObjectField>[] = useMemo(() => {
    return (filteredFields || []).map(objectField => ({
      data: objectField,
      tabIndex: 0,
      id: objectField.fieldName
    }));
  }, [filteredFields]);

  return (
    <Table
      columns={columns}
      rows={rows}
      globalContext={tableGlobalContext}
      withoutShadow
      compactHeader
      classes={{ containerClass: 'h-100' }}
      forceFullWidth
      fillSpace
    />
  );
}
